/**
 * Supabase Proxy - Secure wrapper for Supabase operations
 * Ce fichier remplace les appels directs à Supabase par des appels via Edge Function
 * 
 * IMPORTANT: Configurez l'URL de votre Edge Function ci-dessous
 */

const SUPABASE_EDGE_FUNCTION_URL = 'https://jylosoogxfkryksdvxdq.supabase.co/functions/v1/product-views';

/**
 * Incrémente le compteur de vues pour un produit
 * @param {string|number} productId - ID du produit Shopify
 * @returns {Promise<{success: boolean}>}
 */
async function incrementProductView(productId) {
  try {
    const response = await fetch(SUPABASE_EDGE_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'increment',
        productId: String(productId)
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('[Product Views] Error incrementing view:', error);
    return { success: false, error: error.message };
  }
}

/**
 * Récupère le top 50 des produits les plus vus
 * @returns {Promise<{products: Array<{product_id: string}>}>}
 */
async function getTopProducts() {
  try {
    const response = await fetch(SUPABASE_EDGE_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'getTop'
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('[Product Views] Error fetching top products:', error);
    return { products: [], error: error.message };
  }
}

/**
 * Vérifie si un produit est dans le top 50
 * @param {string|number} productId - ID du produit à vérifier
 * @returns {Promise<boolean>}
 */
async function isProductInTop50(productId) {
  try {
    const { products } = await getTopProducts();
    const topProductIds = products.map(p => String(p.product_id));
    return topProductIds.includes(String(productId));
  } catch (error) {
    console.error('[Product Views] Error checking top product:', error);
    return false;
  }
}

// Export pour utilisation dans le thème
window.SupabaseProxy = {
  incrementProductView,
  getTopProducts,
  isProductInTop50
};
